<!-- E200系Steps項目 -->
<p-steps [model]="stepsItems" [activeIndex]="activeIndex"></p-steps>
